import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = {
  key: 0,
  class: "m-0"
}
const _hoisted_3 = {
  key: 1,
  id: "logout-btn"
}

import { ISession } from '@/interfaces';
import LogoutItem from '../LogoutItem.vue';
import PWAInstallButton from '../PWAInstallButton.vue';
import PWAInstallModal from '../Modals/PWAInstallModal.vue';
import { useRouter } from 'vue-router';
import paths from '@/router/paths';


export default /*@__PURE__*/_defineComponent({
  __name: 'NavbarRightItem',
  props: {
    session: {}
  },
  setup(__props: any) {

const router = useRouter();



const goToProfile = () => {
  router.push(paths.more.root);
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PWAInstallButton),
    (_ctx.session)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.session.is_registration_complete)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_2, [
                _createElementVNode("div", {
                  class: "d-flex cursor-pointer",
                  onClick: goToProfile
                }, [
                  _createTextVNode(_toDisplayString(_ctx.session.first_name) + " ", 1),
                  _cache[0] || (_cache[0] = _createElementVNode("span", { class: "fas fa-user-circle text-dark50 ms-2" }, null, -1))
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(LogoutItem)
              ]))
        ], 64))
      : (_openBlock(), _createBlock(_component_router_link, {
          key: 1,
          to: _ctx.$paths.login,
          id: "nav-login-btn",
          class: "btn btn-sm btn-dark"
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode(" Entrar ")
          ])),
          _: 1
        }, 8, ["to"])),
    _createVNode(PWAInstallModal)
  ]))
}
}

})